export default {
	title: "Web3",
	rule: "Szabályok leírása",
	safe: "Pénzügyi biztonság",
	balance: {
		total: "Teljes összeg",
		yesterday: "Tegnapi bevétel",
		cumulatively: "Kumulatív bevétel",
		in: "Bevételt összeg",
		out: "Kifizetett összeg",
		available: "Rendelkezésre álló egyenleg"
	},
	actions: {
		in: "Bevétel",
		out: "Kifizetés"
	},
	type: ["Mind", "Bevétel", "Kifizetés", "Bevétel"],
	TransactionPassword: "Tranzakciósi jelszó",
	Amount: "Összeg",
	date: "Dátum"
};
